import { render } from "./ProfileInfo.vue?vue&type=template&id=488cf8a4&scoped=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"

import "./ProfileInfo.vue?vue&type=style&index=0&id=488cf8a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.40_webpack@5.109.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488cf8a4"]])

export default __exports__